import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, required, ...props }, ref) => {
  return (
    <input
      type={type}
      aria-required={required || undefined}
      className={cn(
        "flex h-9 w-full rounded-md border border-[hsl(var(--input-border))] bg-[hsl(var(--input-bg))] text-[hsl(var(--input-fg))] px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[hsl(var(--input-ph))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        required && "ui-required",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
